import React, { useState, useEffect } from 'react';
import { Alert, Modal, Form, Button, Row, Col, Card, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getAcademicStory, saveAcademicStory, editAcademicStory, deleteAcademicStory } from '../../redux/academicStory/actions';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarConfig from '../../components/SidebarConfig';
import messages from '../../redux/messages';
import CustomTable from '../../components/CustomTable';

const AcademicStory = props => {

  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);

  const columns = [
    {
      Header: 'Codigo',
      accessor: 'codigo'
    },
    {
      Header: 'Descripción',
      accessor: 'descripcion'
    },
    // {
    //   Header: 'Service tag',
    //   accessor: 'service_tag'
    // },
    // {
    //   Header: 'Estado',
    //   accessor: 'estado',
    //   Filter: ''
    // },
    {
      Header: 'Documento',
      accessor: 'documento',
      // Filter: '',
    },
    {
      id: 'customButtons',
      Filter: '',
      Cell: value => (<div
        className="btn-group"
        role="group">
        <Button
          size="sm"
          variant="link"
          type="button"
          onClick={() => onEdit(value.row.original, value.row.index)}>
          <i className="material-icons">edit</i>
        </Button>
        <Button
          size="sm"
          className="text-danger"
          variant="link"
          type="button"
          onClick={() => onDelete(value.row.original.id, value.row.index)}>
          <i className="material-icons">close</i>
        </Button>
      </div>)
    }
  ];

  //Redux
  const dispatch = useDispatch();
  //EmerContact
  const loading = useSelector(store => store.academicStory.loading);
  const data = useSelector(store => store.academicStory.academicStory);
  const dataLenght = useSelector(store => store.academicStory.academicStoryLength);
  const saveAcademicStoryLoader = useSelector(store => store.academicStory.saveLoader);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    setValidated(false);
  }

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    setValidated(false);
  }

  useEffect(() => {
    dispatch(getAcademicStory({empleado: props.match.params.id}, parseInt(props.match.params.type)));
  }, [dispatch, props.match.params.id, props.match.params.type]);

  const onSubmit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    // const oData = {
    //   // if(e.target.picFile.files.length > 0){
    //   //   req.append('foto', e.target.picFile.files[0]);
    //   // },
    //   codigo: e.target.codigo.value,
		// 	descripcion: e.target.descripcion.value,
		// 	documento: e.target.documento.value,
		// 	// estado: e.target.estado.value,
		// 	//sociedad: parseInt(e.target.sociedad.value),
		// 	//parentesco: parseInt(e.target.relativeRelationShip.value),
		// 	empleado: parseInt(props.match.params.id)
    // }

    // if(edit){
    //   dispatch(editAcademicStory(oData, editItem.id, index));
    // }else{
    //   dispatch(saveAcademicStory(oData));
    // }
    const req = new FormData();
    if(e.target.picFile.files.length > 0){
      req.append('documento', e.target.picFile.files[0]);
    }
    req.append('descripcion', e.target.descripcion.value);
    req.append('codigo', e.target.codigo.value);
    console.log(req);
    if(!edit){
      dispatch(saveAcademicStory(req, parseInt(props.match.params.type)));
      e.target.reset();
      setShowModal(false);
    } else {
      dispatch(editAcademicStory(req, editItem.id, index, parseInt(props.match.params.type)));
      setShowModal(false);
    }

  }

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteAcademicStory(id, index, parseInt(props.match.params.type)));
    }
  }
  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1">
            <h2 className="font-weight-bold d-flex justify-content-between align-items-center text-uppercase">{ props.match.params.name }
              <Button
                variant="primary"
                size="sm"
                onClick={() => onAdd()}>Agregar nuevo</Button>
            </h2>
            <hr />
            <h6>Historial académico</h6>
          </div>
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center" />
              </div>
            ) : data.length > 0 ? (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={data} />
                  </Card.Body>
                </Card>
              </>
            ) : (
              <Alert variant="info" className="my-4">
                Este empleado no tiene un historial académico aún, comience creandolo
              </Alert>
            )
          }
        </div>
      </div>
      <Modal
        show={showModal}
        size="lg"
        onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>{edit ? 'Editar historial académico' : 'Crear historial académico'}</Modal.Title>
          </Modal.Header>
          {
              edit && (
                <img src={`${process.env.REACT_APP_URL}${editItem.documento}`} alt="documento" />
              )
            }
          <Modal.Body >
            <Row>
            <Form.Group as={Col} sm="12" md="12" lg="4" controlId="codigo">
                <Form.Label className="ml-2">Código</Form.Label>
                <Form.Control
                  name="codigo"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[A-Za-z0-9]+"
                  defaultValue={edit ? editItem.codigo : null}
                  placeholder="Código"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="picFile" className="mb-3">
              <Form.Label>Seleccione un documento</Form.Label>
              <Form.Control
                required={!edit} 
                name="picFile" 
                type="file" 
                accept=".jpeg, .jpg, .png, .pdf" />
            </Form.Group>
              {/* <Form.Group as={Col} controlId="documento">
                <Form.Label className="ml-2">Documento</Form.Label>
                <Form.Control
                  name="documento"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[a-zA-Z][a-zA-Z\s]*"
                  defaultValue={edit ? editItem.documento : null}
                  placeholder="Descripción de equipo"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group> */}
              <Form.Group as={Col} sm="12" md="12" lg="4" controlId="descripcion">
                <Form.Label className="ml-2">Descripción</Form.Label>
                <Form.Control
                  name="descripcion"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[A-Za-z0-9]+"
                  defaultValue={edit ? editItem.descripcion : null}
                  placeholder="Descripción"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}>
              Cerrar
            </Button>
            <Button
              className="rounded-pill" 
              disabled={saveAcademicStoryLoader}  
              variant="primary" 
              type="submit">
                {
                  saveAcademicStoryLoader ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true" />
                  ): null
                }
                Guardar</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  )
}

export default AcademicStory
